import { httpRequest } from "../../../utils/HttpRequest";
import { IPurchaseOfferSearch, IPurchaseOfferDetail, IPurchaseOfferFields, Detailed, IPurchaseOfferList, IPurchaseOfferStatistics } from "./purchaseOfferType"
class PurchaseOfferService {
    async page(searchVo: IPurchaseOfferSearch) {
        const apiUrl = "/zzw-vrm/purchaseOffer/findPage";
        return await httpRequest.post<IPurchaseOfferList>(apiUrl, searchVo);
    }
    async total(searchVo: IPurchaseOfferSearch) {
        const apiUrl = "/zzw-vrm/purchase/offer/total";
        return await httpRequest.post<IPurchaseOfferStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/purchaseOffer/findById/${id}`;
        return await httpRequest.get<IPurchaseOfferDetail>(apiUrl);
    }

    async insert(insertVo: IPurchaseOfferFields) {
        const apiUrl = "/zzw-vrm/purchaseOffer/insert";
        return await httpRequest.post<IPurchaseOfferDetail>(apiUrl, insertVo);
    }
    async update(updateVo: IPurchaseOfferFields) {
        const apiUrl = "/zzw-vrm/purchaseOffer/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async updateList(updateVo: any) {
        const apiUrl = "/zzw-vrm/purchaseOfferDetails/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //明细删除
    async materialDelete(params: Detailed) {
        const apiUrl = "/zzw-vrm/purchase/offer/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导出
    async export(params: IPurchaseOfferSearch) {
        const apiUrl = `/zzw-vrm/purchaseOffer/export`;
        return await httpRequest.postFile(apiUrl, params);
    }
    //明细导出
    async exportDetail(code: string) {
        const apiUrl = `/zzw-vrm/purchaseOfferDetails/export/${code}`;
        return await httpRequest.postFile(apiUrl, {});
    }
    //提交
    async submit(id: string) {
        const apiUrl = `/zzw-vrm/purchaseOffer/submit/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    async toReport(id: string) {
        const apiUrl = `/zzw-vrm/purchaseOffer/submit/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //转采购单
    async demo(offerCode: string) {
        const apiUrl = `/zzw-vrm/purchase/offer/transfer/${offerCode}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    async transfer(searchVo: any) {
        const apiUrl = "/zzw-vrm/purchaseOffer/offer";
        return await httpRequest.post<IPurchaseOfferStatistics>(apiUrl, searchVo);
    }
    //下载模板
    async downloadTpl() {
        // const apiUrl = "/zzw-vrm/purchase/offer/detail/downloadTpl";
        const apiUrl = "/zzw-vrm/purchase/detail/downloadTpl";
        return await httpRequest.getFile<boolean>(apiUrl);
    }
    //打印次数
    async printNum(id: string) {
        const apiUrl = `/zzw-vrm/purchase/offer/print/${id}`;
        return await httpRequest.get(apiUrl);
    }
}

export const purchaseOfferService = new PurchaseOfferService();